<template>
  <div>
    <div class="question__item">
      <BaseContent :info="params"></BaseContent>
      <el-form class="question__form">
        <el-form-item class="question__form--item">
          <div class="group__item">
          <el-cascader
            v-model="cascaderVal"
            :options="options"
            @change="handleChange">
          </el-cascader>
          </div>
        </el-form-item>
      </el-form>
      <ErrMessage
        v-show="errShow"
        :visible="errShow"
        :errTitle="errTitle"
      >
      </ErrMessage>
    </div>
    <check-item
      :check="params.check"
      :form="form"
      v-on="$listeners"
      v-bind="$attrs"
      @upCheck="upCheck"></check-item>
  </div>
</template>
<script>
import ErrMessage from '../../components/errorMessage'
import BaseContent from './baseContent'
import { BASE_TYPE_CHECK_DATA_FUN } from '../constant/index'
import * as CHECK_DATA_FUN from '../constant/method'
import { mixin } from '../constant/mixin'
import CheckItem from './checkItem'
export default {
  name: 'cascade',
  props: {
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    ErrMessage,
    BaseContent,
    CheckItem
  },
  computed: {
    cascadeValue () {
      let { selectFirstText = '', selectSecondText = '' } = this.form
      return `${selectFirstText}${selectSecondText}`
    },
    checkFun () {
      return CHECK_DATA_FUN[BASE_TYPE_CHECK_DATA_FUN[this.form.q_category]]
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('pick', val)
      },
      deep: true
    }
  },
  mixins: [mixin],
  data () {
    return {
      dialogVisible: false,
      form: {
        firstCascade: '',
        secondCascade: '',
        selectFirstText: '',
        selectSecondText: '',
        question_text: '',
        q_category: '',
        question_id: '',
        q_option_id: '',
        q_answer_info: '',
        q_remark: '',
        q_is_required: 0,
        o_is_required: 0,
        o_has_input: 0,
        o_is_conflict: 0,
        option: [],
        data_datetime: '',
        is_kaocha: '',
        remark: '',
        q_group_id: '',
        q_number: '',
        cascaderVal: []
      },
      options: [], // 及联器所需数据结构
      cascaderVal: [], // 及联器选中id
      info: {},
      errShow: false,
      errTitle: ''
    }
  },
  methods: {
    checkData (isSubmit) {
      let checkResult = this.checkFun(this.form, this.params)
      if (checkResult.noData) {
        this.errShow = true
        this.errTitle = checkResult.errTitle
      } else {
        this.errShow = false
        !isSubmit && this.logicalHandler()
      }
    },
    showDailog () {
      this.$refs.dialog.setData(this.form)
      this.dialogVisible = true
    },
    selectHandler (info) {
      this.form = { ...this.form, ...info }
      setTimeout(() => {
        this.checkData()
      }, 500)
    },
    handleChange (val) {
      this.form.firstCascade = val[0]
      this.form.secondCascade = val[1]
      this.form.cascaderVal = this.cascaderVal
      this.checkData()
    },
    upCheck (val) {
      this.form = Object.assign(this.form, val)
    }
  },
  mounted () {
    this.info = { ...this.info, ...this.params }
    Object.keys(this.form).forEach(item => {
      this.form[item] = this.params[item] || ''
      if (item === 'data_datetime') {
        this.form[item] = this.params.check[0] && this.params.check[0].data_datetime
      }
      if (item === 'remark') {
        this.form[item] = this.params.check[0] && this.params.check[0].remark
      }
    })
    this.options = []
    if (!this.params.option) return
    this.params.option.forEach((item, index) => {
      if (item.o_default_selected === 1) {
        this.form.firstCascade = item.o_id
        this.form.selectFirstText = item.o_name
        this.cascaderVal.push(item.o_id)
        item.son.forEach(s_item => {
          if (s_item.o_default_selected === 1) {
            this.form.secondCascade = s_item.id
            this.cascaderVal.push(s_item.id)
            this.form.selectSecondText = s_item.o_name
          }
        })
      }
      this.form.cascaderVal = this.cascaderVal
      // 整理及联起数据结构
      this.options.push({
        label: item.o_name,
        value: item.o_id,
        children: []
      })
      if (item.son.length) {
        this.options[index].children = []
        item.son.forEach(s_item => {
          this.options[index].children.push({
            label: s_item.o_name,
            value: s_item.id
          })
        })
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.el-cascader-panel{
  max-height: 300px !important
}
</style>
